import CitySEOHead from "@/components/feature/CitySEOHead";
import WindermereHeroSection from "./components/HeroSection";
import WindermereStickyNav from "./components/StickyNav";
import WindermereProcessingTimeSection from "./components/ProcessingTimeSection";
import WindermereServicesSection from "./components/ServicesSection";
import WindermereLocalAreaSection, { landmarks } from "./components/LocalAreaSection";
import WindermereTravelTimingSection from "./components/TravelTimingSection";
import WindermereDestinationsSection from "./components/DestinationsSection";
import WindermereTestimonialsSection from "./components/TestimonialsSection";
import WindermereAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WindermereComparisonSection from "./components/ComparisonSection";
import WindermereMistakesSection from "./components/MistakesSection";
import WindermereHowItWorksSection from "./components/HowItWorksSection";
import WindermereFAQSection, { faqs } from "./components/FAQSection";
import WindermereHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WindermereFinalCTA from "./components/FinalCTA";

const areaServedList = [
  { "@type": "City", name: "Windermere" },
  { "@type": "City", name: "Winter Garden" },
  { "@type": "City", name: "Dr. Phillips" },
  { "@type": "City", name: "Gotha" },
  { "@type": "City", name: "Ocoee" },
  { "@type": "City", name: "Horizon West" },
  { "@type": "City", name: "Bay Lake" },
  { "@type": "AdministrativeArea", name: "Orange County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Windermere, Winter Garden, Dr. Phillips, and Orange County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function WindermerePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Windermere"
        state="Florida"
        stateAbbr="FL"
        route="/windermere"
        title="Emergency Passport Windermere, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Windermere, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Orange County lakefront families, Disney-area professionals, and travelers."
        geoPlacename="Windermere, Florida"
        geoPosition="28.4956;-81.5348"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Florida"
        statePageRoute="/states/florida"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={landmarks}
      />
      <WindermereHeroSection />
      <WindermereStickyNav />
      <WindermereProcessingTimeSection />
      <WindermereLocalAreaSection />
      <WindermereServicesSection />
      <WindermereTravelTimingSection />
      <WindermereDestinationsSection />
      <WindermereTestimonialsSection />
      <WindermereAcceptanceFacilitiesSection />
      <WindermereComparisonSection />
      <WindermereMistakesSection />
      <WindermereHowItWorksSection />
      <WindermereFAQSection />
      <WindermereHelpfulResourcesSection />
      <WindermereFinalCTA />
    </div>
  );
}